import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  UserApi,
  UserProfileDeletionReasonEnum,
  UserResponseDto,
  UserUpdatePasswordCommand,
} from "api";

import featureAnnouncementService from "services/featureAnnouncements";
import paymentPurposeService from "services/paymentPurpose";

const userApi = new UserApi();

export interface UserState {
  user: UserResponseDto | null;
}

const initialState: UserState = {
  user: null,
};

export const getUser = createAsyncThunk<UserResponseDto>(
  "user/get",
  async () => {
    const { data } = await userApi.apiUserGet();
    return data;
  },
);

export const updateUserPassword = createAsyncThunk<
  void,
  UserUpdatePasswordCommand
>("user/updatePassword", async (body: UserUpdatePasswordCommand) => {
  await userApi.apiUserPasswordPut(body);
});

export const deleteUser = createAsyncThunk<
  void,
  { reason: UserProfileDeletionReasonEnum[]; notes?: string }
>("user/delete", async ({ reason, notes }) => {
  await userApi.apiUserDelete(reason, notes);

  paymentPurposeService().clearPaymentPurpose();
  featureAnnouncementService().clearFeatureAnnouncements();
});

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserId(state, action) {
      state.user = { userUid: action.payload } as UserResponseDto;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(deleteUser.fulfilled, (state) => {
      state.user = null;
    });
  },
});

export const { setUserId } = userSlice.actions;
export default userSlice.reducer;
